import axios from 'axios'
import { getToken } from '@/store/token'

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || 'https://zlyswebapi.larryms.com',
    timeout: 15000,
    headers: {
        'Content-Type': 'application/json'
    },
    transformRequest: [
        function (data) {
            if (data && Object.prototype.toString.call(data) === '[object Object]') {
                return JSON.stringify(data)
            }

            return data
        }
    ]
})

instance.interceptors.request.use(
    config => {
        const token = getToken()

        config.headers = config.headers || {}
        config.headers['Content-Type'] = 'application/json'

        if (token) {
            config.headers.Authorization = token
        }

        return config
    },
    err => {
        console.error('[request error]', err)
        return Promise.reject(err)
    }
)

instance.interceptors.response.use(
    res => {
        /**
         * 后端如果路由错误会返回纯字符串 error request!
         * 这里统一兜底，避免组件拿字符串当对象用。
         */
        if (typeof res.data === 'string') {
            return {
                status: 'failure',
                data: {},
                msg: res.data,
                code: -1
            }
        }

        return res.data || {
            status: 'failure',
            data: {},
            msg: '接口无返回数据',
            code: -1
        }
    },
    err => {
        console.error('[response error]', err)

        return {
            status: 'failure',
            data: {},
            msg: err && err.message ? err.message : '网络请求失败',
            code: -1
        }
    }
)

export function request(config) {
    return instance(config)
}
